// to be used client-side
// TODOLATER: Either convert calling code to callOnce (if possible) or add client-side protection inside this function via import.meta.client so this external const can be internal
const keys: Record<string, boolean> = {}
export default function (key: string, callback: Function) {
  if (keys[key] === true) return

  keys[key] = true
  callback()
}
